export default __webpack_public_path__ + "static/media/guppy-mini.c13a1bdc.glb";